module.exports = Vue;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 211
// module chunks = 1